import {
  selCountPdmgCategoryMJ,
  selCountPdmgCategoryCL,
  selTradingData,
  selLandToScaleProportion,
  selPdmgCategoryDate,
  selTradingBulletinBoard,
  selIncreaseBar,
  selPdmgCategoryTrend,
  selOrderFlow,
  selCategoryTradingData,
  selCategoryAmount,
  statMember,
  statPlatUser,
  selGoodsSpecCount,
  selStatPlantMember,
  selRecordRemindSchemeByTotal,
  selPzmcByTotal,
  selStatPdmgDateTrend,
  selPriceOfferGroupByDate,
} from '@/api/synthetical';

export default {
  namespaced: true,
  actions: {
    // 累计种植面积
    async selCountPdmgCategoryMJ(context, params) {
      const { data } = await selCountPdmgCategoryMJ(params);
      return data;
    },
    // 累计种植产量
    async selCountPdmgCategoryCL(context, params) {
      const { data } = await selCountPdmgCategoryCL(params);
      return data;
    },
    // 累计交易额
    async selTradingData(context, params) {
      const { data } = await selTradingData(params);
      return data;
    },
    // 种植规模
    async selLandToScaleProportion(context, params) {
      const { data } = await selLandToScaleProportion(params);
      return data;
    },
    // 面积与产量
    async selPdmgCategoryDate(context, params) {
      const { data } = await selPdmgCategoryDate(params);
      return data;
    },
    // 实时交易公告板
    async selTradingBulletinBoard(context, params) {
      const { data } = await selTradingBulletinBoard(params);
      return data;
    },
    // 地块累计增长趋势
    async selIncreaseBar(context, params) {
      const { data } = await selIncreaseBar(params);
      return data;
    },
    // top10种植品种
    async selPdmgCategoryTrend(context, params) {
      const { data } = await selPdmgCategoryTrend(params);
      return data;
    },
    // 订单流动
    async selOrderFlow(context, params) {
      const { data } = await selOrderFlow(params);
      return data;
    },
    // 交易品类情况 top
    async selCategoryTradingData(context, params) {
      const { data } = await selCategoryTradingData(params);
      return data;
    },
    // 累计交易额
    async selCategoryAmount(context, params) {
      const { data } = await selCategoryAmount(params);
      return data;
    },
    // 累计用户
    async statMember(context, params) {
      const { data } = await statMember(params);
      return data;
    },
    // 店铺数量
    async statPlatUser(context, params) {
      const { data } = await statPlatUser(params);
      return data;
    },
    // 商品sku
    async selGoodsSpecCount(context, params) {
      const { data } = await selGoodsSpecCount(params);
      return data;
    },
    // 种植户
    async selStatPlantMember(context, params) {
      const { data } = await selStatPlantMember(params);
      return data;
    },
    // 种植方案
    async selRecordRemindSchemeByTotal(context, params) {
      const { data } = await selRecordRemindSchemeByTotal(params);
      return data;
    },
    // 种植品种
    async selPzmcByTotal(context, params) {
      const { data } = await selPzmcByTotal(params);
      return data;
    },
    async selStatPdmgDateTrend(context, params) {
      const { data } = await selStatPdmgDateTrend(params);
      return data;
    },
    async selPriceOfferGroupByDate(context, params) {
      const { data } = await selPriceOfferGroupByDate(params);
      return data;
    },
  },
};
